export default __webpack_public_path__ + "static/media/paypal.ae62fa3d.png";